// extracted by mini-css-extract-plugin
module.exports = {"shadow":"CareersBenefits_shadow__o1_7x","imageWrapper":"CareersBenefits_imageWrapper__fGg8e"};